var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlashDoodle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 140,
    viewBox: "0 0 115 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.380446 113.163C-0.589205 123.371 3.35146 136.196 14.9795 137.867C26.5222 139.453 43.9837 132.262 53.8897 126.373C74.9583 113.809 91.07 93.9551 101.061 71.8223C106.096 60.7674 109.517 48.8811 111.138 36.887C111.813 31.0131 111.378 24.9237 109.594 19.3039C102.566 -2.45173 81.8699 1.38206 64.4395 7.49458C52.8502 11.7441 42.1142 18.1106 31.3627 24.3155C46.7375 13.9612 63.0975 3.46062 81.9009 0.550635C96.5233 -1.92824 108.066 3.96102 112.821 18.2492C115.986 27.4334 115.319 37.295 113.256 46.587C110.122 61.9452 104.079 76.6876 95.6467 89.9288C85.5313 105.772 71.9252 119.691 55.4023 128.96C47.1564 133.579 38.2356 137.051 28.9347 138.867C22.7988 140.161 15.9026 140.908 10.077 137.921C1.11738 133.425 -0.984822 122.177 0.380446 113.155V113.163Z",
    fill: "#161616"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlashDoodle);
export default __webpack_public_path__ + "static/media/slashDoodle.79037510555541eba5e2a84d083d46ca.svg";
export { ForwardRef as ReactComponent };